import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {Dropdown, Modal, OverlayTrigger, Pagination, Table, Tooltip} from 'react-bootstrap'
import '../styles/InvestorUpdates.scss'
import {useNavigate} from 'react-router-dom'
import {deletePitchDeck, getPitchDecks, updatePitchDeck} from '../core/_request'
import {useAuth} from '../../auth'
import {useDateFormat} from '../../../hooks/useDateFormat'
import {DateTime} from 'luxon'
import {toast} from 'react-toastify'
import PitchDeckModal from './PitchDeckModal'
import {useInvestorDatabase} from '../../investor-database/core/InvestorContext'
// import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import {BasicButton} from '../../widgets/components/UI/BasicButton'
// import {Spinner} from '../../widgets/components/General/Spinner'
// import NoDataPage from '../../widgets/components/NoDataPage'
import {roleValues} from '../../../core/_constants'
import {GET_FILE_URL} from '../../onboarding/core/_requests'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import SkeletonLoader from './SkeletonLoader'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'

const PitchDeck = () => {
  const [activePage, setActivePage] = useState(1)
  const {formatMessage} = useIntl()
  const navigate = useNavigate()
  const {companyId, role, currentUser} = useAuth()
  const [pitchDeckData, setpitchDeckData] = useState<any>([])
  const {getDateValue} = useDateFormat()
  const [totalPages, setTotalPages] = useState<number>()
  const {searchPitchDeck, pitchDeckStatusFilter, setStoreFileName} = useInvestorDatabase()
  const [showUpdateModal, setUpdateShowModal] = useState(false)
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [updateLoading, setUpdateLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [status, setstatus] = useState<any>()
  const [pitchDeckId, setpitchDeckId] = useState<any>()
  const [getApiLoading, setApiLoading] = useState(false)

  const getAllPitchDeck = async () => {
    // if (
    //   companyId &&
    //   role &&
    //   (role === roleValues.OWNER || role === roleValues.ADMIN || role === roleValues.IRM)
    // ) {

    if (companyId && role && role === roleValues.OWNER) {
      setApiLoading(true)
      try {
        const {
          data: {
            data: {data, totalCount},
            success,
            errors,
          },
        } = await getPitchDecks(+companyId, activePage, 10, searchPitchDeck, pitchDeckStatusFilter)
        if (success) {
          setTotalPages(Math.ceil(totalCount / 10))
          setpitchDeckData(data)
          setApiLoading(false)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          setApiLoading(false)
        }
      } catch (err) {
        console.log(err)
        setApiLoading(false)
      }
    }
  }

  useEffect(() => {
    getAllPitchDeck()
  }, [companyId, searchPitchDeck, activePage, pitchDeckStatusFilter, role]) // eslint-disable-line react-hooks/exhaustive-deps

  const paginationItems = []
  for (let number = 1; number <= totalPages!; number++) {
    paginationItems.push(
      <Pagination.Item
        key={number}
        active={number === activePage}
        onClick={() => setActivePage(number)}
      >
        {number}
      </Pagination.Item>
    )
  }

  const handleDelete = async (pitchDeckId: number) => {
    try {
      setDeleteLoading(true)
      const {
        data: {success, errors},
      } = await deletePitchDeck(pitchDeckId)
      if (success) {
        setDeleteShowModal(false)
        setDeleteLoading(false)
        getAllPitchDeck()
        toast.success(formatMessage({id: 'Pitch Deck deleted Successfully'}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DeletePitchDeckSuccessful,
            action: 'normal',
            metadata: {
              pitch_deck_id: pitchDeckId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
            },
          },
        })
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
        setDeleteLoading(false)
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DeletePitchDeckFailed,
            action: 'normal',
            metadata: {
              pitch_deck_id: pitchDeckId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              error: errors[0],
            },
          },
        })
      }
    } catch (err) {
      console.log(err)
      setDeleteLoading(false)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DeletePitchDeckFailed,
          action: 'normal',
          metadata: {
            pitch_deck_id: pitchDeckId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            error: err,
          },
        },
      })
    }
  }

  const handleUpdate = async (pitchDeckId: number, status: string) => {
    if (pitchDeckId) {
      try {
        setUpdateLoading(true)
        let payload
        if (status === 'PUBLISHED') {
          payload = {status: 'DRAFT'}
        } else if (status === 'DRAFT') {
          payload = {status: 'PUBLISHED'}
        } else {
          payload = {status: 'DRAFT'}
        }
        const {
          data: {success, errors},
        } = await updatePitchDeck(payload, pitchDeckId)
        if (success) {
          setUpdateShowModal(false)
          getAllPitchDeck()
          toast.success(formatMessage({id: 'Pitch Deck updated Successfully'}))
          setUpdateLoading(false)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdatePitchDeckStatusSuccessful,
              action: 'normal',
              metadata: {
                pitch_deck_id: pitchDeckId,
                status: payload?.status,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          setUpdateLoading(false)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdatePitchDeckStatusFailed,
              action: 'normal',
              metadata: {
                pitch_deck_id: pitchDeckId,
                status: payload?.status,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                error: errors[0],
              },
            },
          })
        }
      } catch (err) {
        console.log(err)
        setUpdateLoading(false)
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.UpdatePitchDeckStatusFailed,
            action: 'normal',
            metadata: {
              pitch_deck_id: pitchDeckId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              error: err,
            },
          },
        })
      }
    }
  }
  const renderSkeletonRows = () => {
    const skeletonRows = []
    for (let i = 0; i < 8; i++) {
      skeletonRows.push(
        <tr key={i}>
          <td colSpan={8}>
            <SkeletonLoader />
          </td>
        </tr>
      )
    }
    return skeletonRows
  }
  return (
    <>
      <div className='investor-updates-container '>
        <div className='card row'>
          <div className='card-body'>
            <div className='table table-responsive h-100'>
              <Table className='w-100'>
                <thead className='custom-thead'>
                  <tr className='font-size-12 font-weight-400 table-row border-dark-mode'>
                    <td className='min-w-100px'>{formatMessage({id: 'Title'})}</td>
                    <td className='min-w-100px'>{formatMessage({id: 'Created On'})}</td>
                    <td className='min-w-100px'>{formatMessage({id: 'Created By'})}</td>
                    <td className='min-w-100px text-center '>{formatMessage({id: 'Status'})}</td>
                    <td className='min-w-100px'>{formatMessage({id: 'Sent'})}</td>
                    <td className='min-w-100px'>{formatMessage({id: 'Opened'})}</td>
                    <td className='min-w-150px'>{formatMessage({id: 'Analytics'})}</td>
                    <td className='min-w-100px'>{formatMessage({id: 'Actions'})}</td>
                  </tr>
                </thead>
                <tbody>
                  {getApiLoading ? (
                    renderSkeletonRows()
                  ) : !getApiLoading && pitchDeckData.length === 0 ? (
                    <tr>
                      <td colSpan={8}>
                        <div
                          className={`d-flex align-items-center justify-content-center flex-column text-center  `}
                          style={{
                            marginTop: '10%',
                          }}
                        >
                          <div style={{order: 1}}>
                            <img
                              src={toAbsoluteUrl('/media/icons/investor-updates/NoDataImg.svg')}
                              alt='no-data-img'
                              height={200}
                              width={200}
                            />
                          </div>
                          <div className='w-100' style={{order: 2}}>
                            <>
                              <h1>{formatMessage({id: 'Nothing to show'})}</h1>

                              <p className='w-100 px-10'>
                                {formatMessage({
                                  id: "Currently we don't have anything to show here",
                                })}
                              </p>
                            </>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    pitchDeckData?.map((pitchDeck: any) => (
                      <tr className='table-tbody-row border-dark-mode' key={pitchDeck?.pitchDeckId}>
                        <td>{pitchDeck?.title ? pitchDeck?.title : '-'}</td>
                        <td>
                          {pitchDeck?.createdAt
                            ? getDateValue(pitchDeck?.createdAt?.toString())
                            : DateTime.fromISO(pitchDeck?.createdAt?.toString()).toLocaleString(
                                DateTime.DATE_MED
                              )}
                        </td>
                        <td>
                          <OverlayTrigger
                            placement='bottom'
                            overlay={
                              <Tooltip id='tooltip'>
                                <p className='m-0'>
                                  {pitchDeck?.user?.firstName} {pitchDeck?.user?.lastName}
                                </p>
                              </Tooltip>
                            }
                          >
                            <img
                              src={
                                pitchDeck?.user?.file?.name
                                  ? `${GET_FILE_URL}/${encodeURIComponent(
                                      pitchDeck?.user?.file?.name || ''
                                    )}`
                                  : toAbsoluteUrl('/media/icons/duotune/general/user1.svg')
                              }
                              height='20'
                              width='20'
                              alt='user'
                              style={{objectFit: 'contain'}}
                              className='ms-5'
                            />
                          </OverlayTrigger>
                        </td>
                        <td className='text-center'>
                          {pitchDeck?.status === 'DRAFT' ? (
                            <p className='badge badge-light-primary all-badge'>
                              {formatMessage({id: pitchDeck?.status})}
                            </p>
                          ) : pitchDeck?.status === 'PUBLISHED' ? (
                            <p className='badge badge-light-success all-badge'>
                              {formatMessage({id: pitchDeck?.status})}
                            </p>
                          ) : (
                            <p className='badge badge-light-success all-badge'>
                              {formatMessage({id: pitchDeck?.status})}
                            </p>
                          )}
                        </td>
                        <td>{pitchDeck?.sendCount && pitchDeck?.sendCount}</td>
                        <td>{pitchDeck?.openCount && pitchDeck?.openCount}</td>
                        <td>
                          <OverlayTrigger
                            placement='bottom'
                            overlay={
                              <Tooltip id='tooltip'>
                                <p className='m-0'>{`Send Count: ${
                                  pitchDeck?.sendCount && pitchDeck?.sendCount
                                }, Open Count: ${pitchDeck?.openCount && pitchDeck?.openCount}`}</p>
                              </Tooltip>
                            }
                          >
                            <span className='font-color'>
                              {formatMessage({id: 'Metrics Details'})}
                            </span>
                          </OverlayTrigger>
                        </td>
                        <td>
                          <div className='dropdown-container'>
                            <Dropdown align={'end'} drop='end'>
                              <Dropdown.Toggle className='bi bi-three-dots-vertical p-1'></Dropdown.Toggle>
                              <Dropdown.Menu className='m-2'>
                                <Dropdown.Item className='text-primary'>
                                  <p
                                    className='mb-0'
                                    onClick={() => {
                                      setStoreFileName(pitchDeck?.file?.name)
                                      navigate(`/updates/pdf/${pitchDeck?.pitchDeckId}`)
                                    }}
                                  >
                                    {formatMessage({id: 'Preview'})}
                                  </p>
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() => {
                                    setUpdateShowModal(true)
                                    setstatus(pitchDeck?.status)
                                    setpitchDeckId(pitchDeck?.pitchDeckId)
                                  }}
                                >
                                  {pitchDeck?.status === 'PUBLISHED' ? (
                                    <p className='mb-0'>{formatMessage({id: 'Unpublish'})}</p>
                                  ) : pitchDeck?.status === 'DRAFT' ? (
                                    <p className='mb-0'>{formatMessage({id: 'Publish'})}</p>
                                  ) : (
                                    <p className='mb-0'>{formatMessage({id: 'Unpublish'})}</p>
                                  )}
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className='text-danger'
                                  onClick={() => {
                                    setDeleteShowModal(true)
                                    setpitchDeckId(pitchDeck?.pitchDeckId)
                                  }}
                                >
                                  <p className='mb-0'>{formatMessage({id: 'Delete'})}</p>
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              {!getApiLoading && pitchDeckData?.length > 0 && (
                <div className='d-flex justify-content-end'>
                  <Pagination>
                    <Pagination.First
                      key='first'
                      disabled={activePage === 1}
                      onClick={() => setActivePage(1)}
                    />
                    <Pagination.Prev
                      key='prev'
                      disabled={activePage === 1}
                      onClick={() => setActivePage(activePage - 1)}
                    />

                    {paginationItems}
                    <Pagination.Next
                      key='next'
                      disabled={activePage === totalPages}
                      onClick={() => setActivePage(activePage + 1)}
                    />
                    <Pagination.Last
                      key='last'
                      disabled={activePage === totalPages}
                      onClick={() => setActivePage(paginationItems.length - 1)}
                    />
                  </Pagination>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* )} */}

      {/* update pitch deck confirmation */}
      <Modal
        show={showUpdateModal}
        onHide={() => setUpdateShowModal(false)}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header closeButton>
          <h2>
            {status === 'DRAFT'
              ? formatMessage({id: 'Publish Pitch Deck'})
              : formatMessage({id: 'Unpublish Pitch Deck'})}
          </h2>
        </Modal.Header>
        <Modal.Body>
          <p>
            {status === 'DRAFT'
              ? formatMessage({
                  id: 'Are you sure you want to publish this pitch deck?',
                })
              : formatMessage({
                  id: 'Are you sure you want to unpublish this pitch deck?',
                })}
          </p>
        </Modal.Body>
        <Modal.Footer>
          {/* <BasicButton
            height='44px'
            border='none'
            color='#F5F8FA'
            textColor='#7E8299'
            padding='12px 16px'
            onClick={() => {
              setUpdateShowModal(false)
            }}
            buttonText='Cancel'
            minWidth={56}
          />

          <BasicButton
            height='44px'
            border='1px solid #4776E6'
            color='#4776E6'
            textColor='white'
            padding='12px 24px'
            onClick={() => {
              handleUpdate(pitchDeckId, status)
            }}
            buttonText='Confirm Update'
            minWidth={56}
            loading={updateLoading}
            disabled={updateLoading}
          /> */}
          <div className='d-flex flex-md-row flex-column justify-content-md-end gap-2 w-100'>
            <BasicButton
              onClick={() => {
                setUpdateShowModal(false)
              }}
              buttonText='Cancel'
              customClass='w-md-auto w-100 custom-button-property bg-light text-muted order-2 order-md-1'
            />

            <BasicButton
              onClick={() => {
                handleUpdate(pitchDeckId, status)
              }}
              buttonText='Confirm Update'
              customClass='w-md-auto w-100 custom-button-property bg-primary text-white order-1 order-md-2'
              loading={updateLoading}
              disabled={updateLoading}
            />
          </div>
        </Modal.Footer>
      </Modal>
      {/* delete pitch deck confirmation */}
      <Modal
        show={showDeleteModal}
        onHide={() => setDeleteShowModal(false)}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header closeButton>
          <h2>{formatMessage({id: 'Delete Pitch Deck'})}</h2>
        </Modal.Header>
        <Modal.Body>
          <p>
            {formatMessage({
              id: 'Are you sure you want to Delete this pitch deck?',
            })}
          </p>
        </Modal.Body>
        <Modal.Footer>
          {/* <BasicButton
            height='44px'
            border='none'
            customClass='btn-light text-dark'
            padding='12px 16px'
            onClick={() => {
              setDeleteShowModal(false)
            }}
            buttonText='Cancel'
            minWidth={56}
          />

          <BasicButton
            height='44px'
            border='1px solid #4776E6'
            color='#4776E6'
            textColor='white'
            padding='12px 24px'
            onClick={() => {
              handleDelete(pitchDeckId)
            }}
            buttonText='Confirm Delete'
            minWidth={56}
            loading={deleteLoading}
            disabled={deleteLoading}
          /> */}
          <div className='d-flex flex-md-row flex-column justify-content-md-end gap-2 w-100'>
            <BasicButton
              onClick={() => {
                setDeleteShowModal(false)
              }}
              buttonText='Cancel'
              customClass='w-md-auto w-100 custom-button-property bg-light text-muted order-2 order-md-1'
            />

            <BasicButton
              onClick={() => {
                handleDelete(pitchDeckId)
              }}
              buttonText='Confirm Delete'
              customClass='w-md-auto w-100 custom-button-property bg-primary text-white order-1 order-md-2'
              loading={deleteLoading}
              disabled={deleteLoading}
            />
          </div>
        </Modal.Footer>
      </Modal>
      <PitchDeckModal getAllPitchDeck={getAllPitchDeck} />
    </>
  )
}

export default PitchDeck
